import { Clock, MessageSquare, TrendingUp, Users } from 'lucide-react';
import { useConversationStats } from '../../hooks/useConversationStats';

export function DashboardStats() {
  const { stats } = useConversationStats();

  return (
    <div className="space-y-4">
      <div className="bg-white/5 backdrop-blur-xl rounded-2xl p-6 border border-white/10">
        <div className="flex justify-between items-start mb-4">
          <MessageSquare className="w-6 h-6 text-indigo-400" />
          <span className={`text-sm ${
            stats.conversationTrend > 0 ? 'text-green-400' : 'text-red-400'
          }`}>
            {stats.conversationTrend > 0 ? '+' : ''}{stats.conversationTrend}%
          </span>
        </div>
        <h3 className="text-2xl font-bold text-white mb-1">{stats.totalConversations}</h3>
        <p className="text-gray-400">Total conversations</p>
      </div>

      <div className="bg-white/5 backdrop-blur-xl rounded-2xl p-6 border border-white/10">
        <div className="flex justify-between items-start mb-4">
          <Users className="w-6 h-6 text-purple-400" />
          <span className={`text-sm ${
            stats.leadsCollectedTrend > 0 ? 'text-green-400' : 'text-red-400'
          }`}>
            {stats.leadsCollectedTrend > 0 ? '+' : ''}{stats.leadsCollectedTrend}%
          </span>
        </div>
        <h3 className="text-2xl font-bold text-white mb-1">{stats.leadsCollected}</h3>
        <p className="text-gray-400">Collected leads</p>
      </div>

      <div className="bg-white/5 backdrop-blur-xl rounded-2xl p-6 border border-white/10">
        <div className="flex justify-between items-start mb-4">
          <Clock className="w-6 h-6 text-pink-400" />
          <span className={`text-sm ${
            stats.durationTrend > 0 ? 'text-green-400' : 'text-red-400'
          }`}>
            {stats.durationTrend > 0 ? '+' : ''}{stats.durationTrend}%
          </span>
        </div>
        <h3 className="text-2xl font-bold text-white mb-1">{stats.averageDuration}</h3>
        <p className="text-gray-400">Average time</p>
      </div>

      <div className="bg-white/5 backdrop-blur-xl rounded-2xl p-6 border border-white/10">
        <div className="flex justify-between items-start mb-4">
          <TrendingUp className="w-6 h-6 text-green-400" />
          <span className={`text-sm ${
            stats.conversionTrend > 0 ? 'text-green-400' : 'text-red-400'
          }`}>
            {stats.conversionTrend > 0 ? '+' : ''}{stats.conversionTrend}%
          </span>
        </div>
        <h3 className="text-2xl font-bold text-white mb-1">{stats.conversionRate}%</h3>
        <p className="text-gray-400">Conversion rate</p>
      </div>
    </div>
  );
}